import { makeStyles } from '@material-ui/core'
import React, { useMemo } from 'react'
import {
    getDeviceShortStatusText,
    isPcbRevisionWithCatchDetectionAdHoc
} from '../../../../utils'
import { isTomDevice } from '../../helpers/is-tom-device'
import { SEVERITY_THEME_COLOR_MAP } from '../../hooks/useReportTypes'
import Trap from './trap'

const useStyles = makeStyles(theme => ({
    root: ({ color }) => ({
        color: theme.textPrimaryReverted,
        padding: '2px 16px',
        borderRadius: 4,
        background: color,
        fontWeight: 'bold'
    }),
    row: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
}))

const DeviceStatusBadge = ({ device, theme, locale, severity }) => {
    const color = theme[SEVERITY_THEME_COLOR_MAP[severity]]
    const statusText = getDeviceShortStatusText(device, locale)
    const classes = useStyles({ color })
    const isTom = useMemo(() => isTomDevice(device?.device_type), [
        device?.device_type
    ])

    if (!device) {
        return
    }

    const hasTrapNumber = device.trap_overwrite === '0'

    const trap1Catch = device.data?.LoRa?.trap1_catch
    const trap2Catch = device.data?.LoRa?.trap2_catch

    return isTom ||
        isPcbRevisionWithCatchDetectionAdHoc(device.pcb_revision) ? (
        <div className={classes.root}>{statusText}</div>
    ) : (
        <div className={classes.row}>
            {['0', '2'].includes(device.trap_overwrite) && (
                <Trap
                    trapNumber={hasTrapNumber ? 1 : undefined}
                    trapStatus={device.trap_1}
                    trapText={locale.common.trap}
                    lastReportType={device.last_report_type}
                    trapCatch={trap1Catch}
                />
            )}
            {['0', '1'].includes(device.trap_overwrite) && (
                <Trap
                    trapNumber={hasTrapNumber ? 2 : undefined}
                    trapStatus={device.trap_2}
                    trapText={locale.common.trap}
                    lastReportType={device.last_report_type}
                    trapCatch={trap2Catch}
                />
            )}
        </div>
    )
}

export default DeviceStatusBadge
